import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Bling as Slider } from 'react-gpt'

Slider.configure({
  renderWhenViewable: false,
  collapseEmptyDiv: true,
  outOfPage: true
})

class AdBanner extends Component {
  componentWillMount () {
    this.urlSlider = '/' + this.props.accountDfp + '/' + this.props.sliderName
    this.setState({ showBanner: false })
  }

  render () {
    setTimeout(() => {
      this.setState({
        showBanner: true
      })
    }, 5000)
    return (
      this.state.showBanner
        ? <Slider
          adUnitPath={this.urlSlider}
          targeting={this.props.targeting}
          sizeMapping={
            this.props.sizeMapping
          }
        />
        : ''
    )
  }
}

AdBanner.propTypes = {
  accountDfp: PropTypes.string.isRequired,
  sliderName: PropTypes.string.isRequired,
  targeting: PropTypes.any,
  sizeMapping: PropTypes.array
}

export default AdBanner



// WEBPACK FOOTER //
// ./src/features/Slider/AdBanner.js